<template>
  <div v-if="step === 1">
    <section
      class="relative flex sm:flex-col sm:items-center md:items-start md:flex-row bg-beige rounded-xl p-9 mb-7 z-50"
    >
      <div class="md:w-2/6 lg:w-1/6 lg:mx-4">
        <div class="flex">
          <div class="bg-white rounded-full">
            <svg
              width="158"
              height="158"
              viewBox="0 0 158 158"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="79" cy="79" r="79" fill="white" />
              <path
                d="M105.438 110.509C104.847 110.509 104.363 110.025 104.363 109.434V94.5857C104.363 93.9943 104.847 93.5105 105.438 93.5105C106.03 93.5105 106.514 93.9943 106.514 94.5857V109.434C106.514 110.025 106.03 110.509 105.438 110.509Z"
                fill="#591144"
              />
              <path
                d="M108.222 95.6599H91.8154C91.2241 95.6599 90.7402 95.1761 90.7402 94.5848C90.7402 93.9935 91.2241 93.5097 91.8154 93.5097H107.04L105.298 75.2008C105.266 74.8998 105.373 74.5987 105.567 74.373C105.771 74.1472 106.061 74.0182 106.362 74.0182H107.287C107.878 74.0182 108.362 74.502 108.362 75.0933C108.362 75.5986 108.007 76.0286 107.534 76.1361L109.276 94.4773C109.308 94.7783 109.201 95.0793 109.007 95.3051C108.814 95.5309 108.524 95.6599 108.222 95.6599Z"
                fill="#591144"
              />
              <path
                d="M98.9443 110.509C98.353 110.509 97.8691 110.025 97.8691 109.434V94.5857C97.8691 93.9943 98.353 93.5105 98.9443 93.5105C99.5357 93.5105 100.019 93.9943 100.019 94.5857V109.434C100.019 110.025 99.5357 110.509 98.9443 110.509Z"
                fill="#591144"
              />
              <path
                d="M92.4502 110.509C91.8588 110.509 91.375 110.025 91.375 109.434V94.5857C91.375 93.9943 91.8588 93.5105 92.4502 93.5105C93.0415 93.5105 93.5253 93.9943 93.5253 94.5857V109.434C93.5253 110.025 93.0415 110.509 92.4502 110.509Z"
                fill="#591144"
              />
              <path
                d="M111.932 89.1668H110.072C109.481 89.1668 108.997 88.683 108.997 88.0916C108.997 87.5003 109.481 87.0164 110.072 87.0164H110.76L109.524 72.3834C108.545 66.8463 105.384 64.1046 99.8686 64.1046H98.0086C96.4603 64.1046 95.0626 64.3304 93.8799 64.7712C93.3208 64.9755 92.708 64.6959 92.493 64.1368C92.2779 63.5777 92.5682 62.9649 93.1273 62.7499C94.5573 62.2123 96.2023 61.9435 98.0086 61.9435H99.8686C106.416 61.9435 110.491 65.4485 111.653 72.0931L112.996 87.9841C113.018 88.2851 112.921 88.5754 112.717 88.8012C112.513 89.027 112.233 89.1668 111.932 89.1668Z"
                fill="#591144"
              />
              <path
                d="M98.9225 59.9749C95.2884 59.9749 92.7402 57.0504 92.7402 52.868C92.7402 48.6856 95.2776 45.7611 98.9225 45.7611C99.5138 45.7611 99.9976 46.2449 99.9976 46.8363C99.9976 47.4276 99.5138 47.9114 98.9225 47.9114C95.955 47.9114 94.8906 50.5779 94.8906 52.868C94.8906 55.1581 95.9442 57.8245 98.9225 57.8245C101.901 57.8245 102.954 55.1581 102.954 52.868C102.954 51.9756 102.815 51.1585 102.524 50.4273C102.309 49.879 102.578 49.2554 103.126 49.0296C103.685 48.8146 104.298 49.0834 104.524 49.6317C104.911 50.6101 105.105 51.696 105.105 52.8572C105.094 57.0611 102.557 59.9749 98.9225 59.9749Z"
                fill="#591144"
              />
              <path
                d="M103.514 51.105C101.02 51.105 98.7187 49.4922 97.9231 47.1914C97.7296 46.6323 98.0199 46.0195 98.5897 45.8259C99.1488 45.6324 99.7616 45.9227 99.9551 46.4925C100.45 47.9225 101.955 48.9654 103.525 48.9654C104.116 48.9654 104.6 49.4492 104.6 50.0406C104.6 50.6319 104.105 51.105 103.514 51.105Z"
                fill="#591144"
              />
              <path
                d="M110.384 59.8456C109.556 59.8456 108.814 59.5446 108.233 58.9855C106.588 57.3836 106.567 54.0185 106.556 51.5672C106.556 51.234 106.556 50.9222 106.545 50.6534C106.449 46.6217 104.492 44.4607 100.75 44.2457L98.2451 44.2135C98.2236 44.2135 98.2128 44.2135 98.1913 44.2135C95.5786 44.2135 91.45 45.9444 91.2887 50.6534C91.2779 50.9437 91.278 51.2877 91.278 51.6748C91.2565 54.0938 91.2242 57.4159 89.6007 58.9963C89.0094 59.5769 88.2567 59.8671 87.3859 59.8456C86.7945 59.8349 86.3215 59.3403 86.3322 58.749C86.343 58.1577 86.8375 57.6524 87.4289 57.6954C87.7084 57.7062 87.9127 57.6309 88.1062 57.4481C89.0846 56.502 89.1169 53.3519 89.1277 51.6533C89.1277 51.2555 89.1384 50.8899 89.1491 50.5781C89.3642 44.3532 94.783 42.0632 98.2128 42.0632C98.2343 42.0632 98.2666 42.0632 98.2881 42.0632L100.847 42.0955C103.739 42.2567 108.545 43.5791 108.728 50.5996C108.739 50.8792 108.739 51.2017 108.739 51.5565C108.749 53.2767 108.76 56.4698 109.76 57.4481C109.943 57.6309 110.158 57.7062 110.437 57.6954C111.007 57.6417 111.523 58.147 111.534 58.749C111.545 59.3511 111.083 59.8349 110.48 59.8456C110.437 59.8456 110.405 59.8456 110.384 59.8456Z"
                fill="#591144"
              />
              <path
                d="M49.3466 92.1024H47.1963C46.6049 92.1024 46.1211 91.6186 46.1211 91.0272V73.5013C46.1211 67.1576 51.3679 61.9966 57.8082 61.9966H62.2487C62.84 61.9966 63.3239 62.4804 63.3239 63.0718C63.3239 63.6632 62.84 64.147 62.2487 64.147H57.8082C52.5506 64.147 48.2714 68.3403 48.2714 73.5013V89.952H49.3466C49.938 89.952 50.4218 90.4359 50.4218 91.0272C50.4218 91.6186 49.938 92.1024 49.3466 92.1024Z"
                fill="#591144"
              />
              <path
                d="M52.5722 111.456C51.9808 111.456 51.497 110.972 51.497 110.381V78.1267C50.9379 78.0945 50.4863 77.6214 50.4863 77.0516C50.4863 76.4603 50.9702 75.9764 51.5615 75.9764H52.5722C53.1635 75.9764 53.6473 76.4603 53.6473 77.0516V110.381C53.6473 110.972 53.1635 111.456 52.5722 111.456Z"
                fill="#591144"
              />
              <path
                d="M61.7431 111.456C61.1518 111.456 60.668 110.972 60.668 110.381V95.3287C60.668 94.7374 61.1518 94.2535 61.7431 94.2535C62.3345 94.2535 62.8183 94.7374 62.8183 95.3287V110.381C62.8183 110.972 62.3345 111.456 61.7431 111.456Z"
                fill="#591144"
              />
              <path
                d="M60.119 59.8466C56.2591 59.8466 53.668 56.8253 53.668 52.3204C53.668 47.8154 56.2591 44.7942 60.119 44.7942C63.9788 44.7942 66.57 47.8154 66.57 52.3204C66.57 56.8146 63.9788 59.8466 60.119 59.8466ZM60.119 46.9445C56.9472 46.9445 55.8183 49.7185 55.8183 52.3204C55.8183 54.9223 56.9472 57.6962 60.119 57.6962C63.2907 57.6962 64.4197 54.9223 64.4197 52.3204C64.4197 49.7185 63.2907 46.9445 60.119 46.9445Z"
                fill="#591144"
              />
              <path
                d="M69.7959 111.456C69.2045 111.456 68.7207 110.972 68.7207 110.381V95.3286C68.7207 94.7372 69.2045 94.2534 69.7959 94.2534C70.3872 94.2534 70.871 94.7372 70.871 95.3286V110.381C70.871 110.972 70.398 111.456 69.7959 111.456Z"
                fill="#591144"
              />
              <path
                d="M86.999 111.456C86.4077 111.456 85.9238 110.972 85.9238 110.381V95.3501C85.9238 94.7587 86.4077 94.2749 86.999 94.2749C87.5903 94.2749 88.0742 94.7587 88.0742 95.3501V110.381C88.0742 110.972 87.6011 111.456 86.999 111.456Z"
                fill="#591144"
              />
              <path
                d="M78.3974 111.456C77.8061 111.456 77.3223 110.972 77.3223 110.381V106.081C77.3223 105.49 77.8061 105.006 78.3974 105.006C78.9888 105.006 79.4726 105.49 79.4726 106.081V110.381C79.4726 110.972 78.9995 111.456 78.3974 111.456Z"
                fill="#591144"
              />
              <path
                d="M93.2565 72.4075C92.7405 72.4075 92.2782 72.0311 92.1921 71.5043C91.2567 65.8167 87.0098 61.9998 81.6232 61.9998H75.1722C69.8286 61.9998 65.5816 65.7844 64.6247 71.4183C64.528 71.9989 63.9796 72.3967 63.3883 72.2999C62.8077 72.2032 62.4099 71.6441 62.5067 71.0635C63.6571 64.3652 68.7427 59.8602 75.1722 59.8602H81.6232C88.1065 59.8602 93.2028 64.4082 94.3102 71.171C94.407 71.7624 94.0092 72.3107 93.4286 72.4075C93.3641 72.3967 93.3103 72.4075 93.2565 72.4075Z"
                fill="#591144"
              />
              <path
                d="M78.3973 57.6978C73.8923 57.6978 70.8711 54.2465 70.8711 49.0965C70.8711 43.9464 73.8923 40.4951 78.3973 40.4951C82.9022 40.4951 85.9235 43.9464 85.9235 49.0965C85.9235 54.2465 82.9022 57.6978 78.3973 57.6978ZM78.3973 42.6455C74.4299 42.6455 73.0214 46.1183 73.0214 49.0965C73.0214 52.0747 74.4299 55.5475 78.3973 55.5475C82.3647 55.5475 83.7731 52.0747 83.7731 49.0965C83.7731 46.1183 82.3647 42.6455 78.3973 42.6455Z"
                fill="#591144"
              />
              <path
                d="M78.3747 101.489C78.2027 101.489 78.0307 101.446 77.8694 101.36C77.3318 101.081 64.7631 94.2749 60.4946 84.8457C60.2474 84.3081 60.4946 83.663 61.0322 83.4265C61.5698 83.1792 62.2149 83.4265 62.4515 83.964C65.9673 91.716 76.0201 97.8337 78.3855 99.1884C80.8046 97.8445 91.223 91.6838 94.513 83.663C94.7388 83.1147 95.3624 82.8459 95.9107 83.0824C96.4591 83.3082 96.7171 83.9318 96.4913 84.4801C92.481 94.2642 79.4069 101.081 78.8586 101.371C78.7188 101.446 78.5468 101.489 78.3747 101.489Z"
                fill="#EA5160"
              />
              <path
                d="M96.5354 78.9532C95.9871 78.9532 95.5248 78.5446 95.471 77.9855C95.0087 73.459 91.2241 70.04 86.6653 70.04C83.3753 70.04 80.4079 73.9751 79.2897 75.6631C78.8919 76.2652 77.9027 76.2652 77.4942 75.6631C76.376 73.9751 73.4085 70.04 70.1185 70.04C65.5813 70.04 61.7107 73.5235 61.3021 77.9748C61.2483 78.5661 60.743 79.0069 60.1302 78.9424C59.5388 78.8886 59.098 78.3618 59.1625 77.7705C59.6786 72.2226 64.4954 67.8789 70.1185 67.8789C73.6343 67.8789 76.5803 70.8034 78.3973 73.201C80.2143 70.8034 83.1495 67.8789 86.6761 67.8789C92.3422 67.8789 97.0515 72.1258 97.6214 77.7597C97.6859 78.3511 97.2558 78.8779 96.6644 78.9424C96.5999 78.9532 96.5677 78.9532 96.5354 78.9532Z"
                fill="#EA5160"
              />
              <path
                d="M59.9362 85.2451C59.5384 85.2451 59.2051 85.1913 58.904 85.0838C58.0869 84.8043 57.5493 84.1269 57.3988 83.2023L56.8935 80.0198C56.7429 79.0951 57.044 78.2887 57.7214 77.7511C58.1837 77.3963 58.7965 77.1598 59.6674 77.02C62.4521 76.5792 63.1187 78.0737 63.2692 78.9984L63.7745 82.1809C63.9251 83.1163 63.624 83.9119 62.9252 84.4387C62.4736 84.7828 61.893 84.9978 61.0329 85.1376H61.0221C60.6028 85.2128 60.248 85.2451 59.9362 85.2451ZM60.6781 79.0844C60.5275 79.0844 60.3233 79.0951 60.0437 79.1381C58.9686 79.3101 58.9901 79.5037 59.0223 79.6757L59.5276 82.8582C59.5491 82.998 59.5814 83.041 59.5814 83.041C59.5814 83.041 59.7749 83.1593 60.6136 83.0302L60.6565 83.0195C61.4952 82.8905 61.6457 82.7184 61.6565 82.7077C61.6565 82.7077 61.6672 82.6539 61.6457 82.5249L61.1404 79.3424C61.1081 79.1596 61.0759 79.1489 61.0329 79.1274C60.9791 79.1059 60.8716 79.0844 60.6781 79.0844Z"
                fill="#591144"
              />
              <path
                d="M96.8801 85.2432C96.5791 85.2432 96.2458 85.2109 95.8695 85.1572C95.8587 85.1572 95.8265 85.1464 95.7942 85.1464C94.9341 85.0066 94.3427 84.7916 93.8912 84.4476C93.1923 83.9207 92.8913 83.1251 93.0418 82.1897L93.5471 79.0072C93.6976 78.0826 94.3535 76.5881 97.1059 77.0181C99.9014 77.459 100.063 79.0932 99.9121 80.0179L99.4068 83.2004C99.2562 84.1358 98.7294 84.8024 97.9015 85.0819C97.6112 85.1894 97.2779 85.2432 96.8801 85.2432ZM96.149 79.0825C95.9555 79.0825 95.848 79.104 95.7835 79.1255C95.7405 79.1362 95.7082 79.1577 95.676 79.3405L95.1706 82.523C95.1491 82.652 95.1706 82.7058 95.1706 82.7058C95.1706 82.7058 95.3104 82.8778 96.1705 83.0176C96.192 83.0176 96.2135 83.0283 96.235 83.0283L96.2781 83.0391C97.0414 83.1574 97.2349 83.0391 97.2564 83.0391C97.2564 83.0391 97.2887 82.9961 97.3102 82.8563L97.8155 79.6738C97.8478 79.5018 97.8693 79.3082 96.8264 79.1362C96.5253 79.0932 96.3103 79.0825 96.149 79.0825Z"
                fill="#591144"
              />
            </svg>
          </div>
        </div>
      </div>
      <div class="md:w-4/6 lg:w-5/6 lg:mx-4 md:pr-10 lg:pr-28">
        <h4 class="font-bold text-violet text-xl mb-4">
          Dokumenty wewnętrzne - <small>poznaj nasze wartości</small>
        </h4>
        <p class="text-sm">
          W tym miejscu przedstawiamy Ci dokumenty, które stanowią fundament dla
          naszej działalności. Jako Organizacja przywiązujemy dużą wagę do ich
          przestrzegania, dlatego zapoznaj się z nimi uważnie i potwierdź, że
          akceptujesz ich treść.
        </p>
      </div>
    </section>
    <header
      v-if="item && item.data"
      class="relative flex bg-cyan-light uppercase font-bold text-sm p-4 rounded-t-xl z-50"
    >
      Ważne dla nas dokumenty
    </header>
    <form
      v-show="!loading"
      id="angRulesForm"
      class="recruitmentForm"
      method="POST"
      :action="action"
    >
      <input type="hidden" name="data[step][1]" :value="1" />
      <section
        v-if="item && item.data"
        class="relative bg-white px-12 pt-8 pb-12 rounded-b-xl z-50"
      >
        <div class="max-w-5xl m-auto">
          <div class="flex w-full mb-20 -mx-3">
            <div class="w-1/2 px-3">
              <div class="h-full">
                <h4
                  class="text-violet uppercase font-bold text-sm mb-4 min-h-[25px]"
                >
                  {{ item.files.instructions[0].name }}
                </h4>
                <p class="text-sm text-[#3D3D3D]">
                  {{ item.files.instructions[0].description }}
                </p>
              </div>
              <span
                @click="downloadOne(item.files.instructions[0].uid)"
                target="_blank"
                class="bg-violet text-white font-bold text-sm px-8 py-2.5 rounded-3xl cursor-pointer"
              >
                Zobacz
              </span>
            </div>
            <div class="w-1/2 px-3">
              <div class="h-full">
                <h4
                  class="text-violet uppercase font-bold text-sm mb-4 min-h-[25px]"
                >
                  {{ item.files.instructions[1].name }}
                </h4>
                <p class="text-sm text-[#3D3D3D]">
                  {{ item.files.instructions[1].description }}
                </p>
              </div>
              <span
                @click="downloadOne(item.files.instructions[1].uid)"
                target="_blank"
                class="bg-violet text-white font-bold text-sm px-8 py-2.5 rounded-3xl cursor-pointer"
              >
                Zobacz
              </span>
            </div>
          </div>
          <div class="flex w-full mb-20 -mx-3">
            <div class="w-1/2 px-3">
              <div class="h-full">
                <h4
                  class="text-violet uppercase font-bold text-sm mb-4 min-h-[25px]"
                >
                  {{ item.files.instructions[2].name }}
                </h4>
                <p class="text-sm text-[#3D3D3D]">
                  {{ item.files.instructions[2].description }}
                </p>
              </div>
              <span
                @click="downloadOne(item.files.instructions[2].uid)"
                target="_blank"
                class="bg-violet text-white font-bold text-sm px-8 py-2.5 rounded-3xl cursor-pointer"
              >
                Zobacz
              </span>
            </div>
            <div class="w-1/2 px-3">
              <div class="h-full">
                <h4
                  class="text-violet uppercase font-bold text-sm mb-4 min-h-[25px]"
                >
                  {{ item.files.instructions[3].name }}
                </h4>
                <p class="text-sm text-[#3D3D3D]">
                  {{ item.files.instructions[3].description }}
                </p>
              </div>
              <span
                @click="downloadOne(item.files.instructions[3].uid)"
                target="_blank"
                class="bg-violet text-white font-bold text-sm px-8 py-2.5 rounded-3xl cursor-pointer"
              >
                Zobacz
              </span>
            </div>
          </div>
          <div class="flex w-full mb-20 -mx-3">
            <div class="w-1/2 px-3">
              <div class="h-full">
                <h4
                  class="text-violet uppercase font-bold text-sm mb-4 min-h-[25px]"
                >
                  {{ item.files.instructions[4].name }}
                </h4>
                <p class="text-sm text-[#3D3D3D]">
                  {{ item.files.instructions[4].description }}
                </p>
              </div>
              <span
                @click="downloadOne(item.files.instructions[4].uid)"
                target="_blank"
                class="bg-violet text-white font-bold text-sm px-8 py-2.5 rounded-3xl cursor-pointer"
              >
                Zobacz
              </span>
            </div>
          </div>
          <div class="mb-5">
            <div class="flex relative text-justify pr-6 form-check-after">
              <input
                type="checkbox"
                class="opacity-0 -mt-1.5 h-8 w-8 z-50 relative cursor-pointer"
                id="ang_documents_chck"
                name="data[consents][ang_documents]"
                value="1"
                required
                :checked="
                  item.data.consents && item.data.consents.ang_documents === '1'
                "
              />
              <label
                class="label-checkbox w-full block mb-0 before:content-[''] before:absolute before:left-0 before:top-[2px] before:border before:border-pink before:h-5 before:rounded-md before:inline-block before:w-5 before:cursor-pointer after:content-[''] after:opacity-0 after:absolute after:top-[5px] after:left-[7px] after:w-[6px] after:h-[12px] after:border-r-2 after:border-b-2 after:border-pink after:rotate-45 after:text-pink after:block after:z-20 after:cursor-pointer"
                for="ang_documents_chck"
              >
                <span class="cursor-pointer text-sm"
                  >Potwierdzam, że znana mi jest treść powyższych dokumentów i
                  akceptuję postanowienia w nich zawarte.</span
                >
              </label>
            </div>
          </div>
        </div>
      </section>
      <div
        class="relative mt-3 bg-[#ffe6e6] p-5 mt-6 rounded-lg border border-red z-50"
        v-if="error"
      >
        <h5 class="text-red font-bold">Wystąpił błąd!</h5>
        <label class="text-red mt-3 error">{{ error }}</label>
      </div>
      <template>
        <div v-if="loading || sending" class="flex justify-center my-3">
          <spinner position="ml-auto" :grid="true"></spinner>
        </div>
        <div v-else class="flex justify-end mt-6">
          <!-- <div
            class="flex items-center bg-transparent border border-violet border-solid rounded-3xl py-3 px-12 font-bold text-violet cursor-pointer z-50 focus:outline-none"
            @click="$emit('back')"
          >
            Wstecz
          </div> -->
          <button
            type="submit"
            class="flex items-center bg-pink border border-pink border-solid rounded-3xl py-3 px-12 font-bold text-white z-50 cursor-pointer focus:outline-none"
          >
            Dalej
          </button>
        </div>
      </template>
    </form>
  </div>
</template>

<script>
import spinner from "@/components/partials/misc/spinner";
import recruitment from "@/mixins/recruitment";
import api from "@/services/api";

export default {
  data() {
    return {
      expanded: false,
    };
  },
  components: {
    spinner,
  },
  mixins: [recruitment],
  name: "AngRules",
  methods: {
    downloadOne(uid) {
      api.get(
        "/hr/recruits/" + this.shortcut + "/file/" + uid,
        {},
        (data) => (window.location.href = data.url)
      );
    },
    toggleCardState() {
      this.expanded = !this.expanded;
    },
  },
};
</script>
